document.addEventListener("DOMContentLoaded", function(){ // Handler when the DOM is fully loaded
	////////////////////////////////////////////////
	////////////// OPEN / CLOSE MENU ///////////////
	/////////////////////////////////////////////////*
	let toggle = document.querySelector('.menu__toggle');
	let toggleClose = document.querySelector('.menu__close');

	if(toggle != null && toggle != ''){
		toggle.onclick = function () {
			document.body.classList.add('page--menu-open');
			document.querySelector(".menu--main").classList.add('menu--open');
		}
	}
	if(toggleClose != null && toggleClose != ''){
		toggleClose.onclick = function () {
			document.body.classList.remove('page--menu-open');
			document.querySelector(".menu--main").classList.remove('menu--open');
		}
	}
});